// extracted by mini-css-extract-plugin
module.exports = {"ProButton":"styles_ProButton__2nPSl"};